<div class="audit-log-job-detail-container">
  <!-- Header Section -->
  <div class="header-section">
    <div class="header-content">
      <button class="btn-blue" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        <span>Back to Audit Logs</span>
      </button>
      <div class="header-text" *ngIf="actionName">
        <h1 class="page-title">{{ actionName }}</h1>
      </div>
    </div>
  </div>

  <!-- Grid Section -->
  @if (isReady) {
    <lib-cdw-ssrm-grid
      class="ag-theme-balham"
      viewKey="audit-log-detail"
      [columnDefs]="columnDefs"
      [itemLabel]="itemLabel"
      [filterBarSettings]="filterBarSettings"
      [cdwSearchGridDataService]="assetChangeDataService"
      [componentId]="componentId"
      [showSelectAllBanner]="false"
      (errorRetrievingData)="onGridLoadError($event)"
    ></lib-cdw-ssrm-grid>
  }
</div>
